import { render, staticRenderFns } from "./SkillsPanel.vue?vue&type=template&id=468ae6d7&scoped=true"
import script from "./SkillsPanel.vue?vue&type=script&lang=js"
export * from "./SkillsPanel.vue?vue&type=script&lang=js"
import style0 from "./SkillsPanel.vue?vue&type=style&index=0&id=468ae6d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468ae6d7",
  null
  
)

export default component.exports